import $ from "jquery";

export function miShowSnackbar(message, type = 'success') {

  const $snackbar = $('#mi-snackbar');


  $snackbar
    .removeClass('mi-snackbar--success mi-snackbar--error mi-snackbar--show')
    .addClass('mi-snackbar--' + type)
    .find('.mi-snackbar__text')
    .text(message);

  $snackbar.addClass('mi-snackbar--show');

  // setTimeout(function () {
  $snackbar.removeClass('mi-snackbar--show');
  $snackbar.show()

  // }, 2000);
}